module.exports = __webpack_public_path__ + "ee65fb4be43f30caab8818f51df97b6a.glb";